import React from 'react';

import { defaultColorPalette } from '@aline/common';
import type { IconVariety } from 'src/components';
import { ColorMenu } from 'src/components';

export function GenericColorSelect({
  color,
  editorLoading,
  hasTransparentOption,
  iconType,
  onSelectColor,
  tooltipTitle,
}: {
  color: string | null;
  editorLoading: boolean;
  hasTransparentOption: boolean;
  iconType: IconVariety;
  onSelectColor: (color: string | null) => void;
  tooltipTitle: string;
}): JSX.Element {
  return (
    <ColorMenu
      defaultColorPalette={defaultColorPalette}
      disabled={editorLoading}
      hasTransparentOption={hasTransparentOption}
      iconType={iconType}
      selectColor={(_e, color) => onSelectColor(color)}
      selectedColor={color}
      tooltipTitle={tooltipTitle}
    />
  );
}
